export default "/images/cloud-drizzle.svg?02fb46d6647033c0f275dd18a3ce14e3";